var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['shadow-card']},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"icon"}),_c('span',{staticClass:"name"}),_c('div',{staticClass:"info"},[_c('div',{staticClass:"name"}),_c('div',{staticClass:"location"}),_c('div',{staticClass:"past-roles"})])])
}]

export { render, staticRenderFns }